import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { EventModel } from './event.model';
import { EventService } from './event.service';

@Injectable({
  providedIn: 'root',
})
export class EventOverviewResolver {
  constructor(private service: EventService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<EventModel> {
    return this.service.getOverview(route.paramMap.get('id') || '').pipe(map((event) => event.data));
  }
}
